import { render, staticRenderFns } from "./QuizPieChart.vue?vue&type=template&id=67ce0e18&scoped=true&"
import script from "./QuizPieChart.vue?vue&type=script&lang=js&"
export * from "./QuizPieChart.vue?vue&type=script&lang=js&"
import style0 from "./QuizPieChart.vue?vue&type=style&index=0&id=67ce0e18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ce0e18",
  null
  
)

export default component.exports